import { render, staticRenderFns } from "./MapPage.vue?vue&type=template&id=5b4d0804&"
import script from "./MapPage.vue?vue&type=script&lang=js&"
export * from "./MapPage.vue?vue&type=script&lang=js&"
import style0 from "./MapPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports